// extracted by mini-css-extract-plugin
export default {"wrapper":"PlayCanvasIntegration_wrapper__AKks1","add":"PlayCanvasIntegration_add__0GbUK"};